type AuraBlobProps = {
  size?: "hero" | "result" | "tiny";
  mood?: "calm" | "loading" | "spicy" | "sweet";
};

export function AuraBlob({ size = "hero", mood = "calm" }: AuraBlobProps) {
  return (
    <svg
      className={`aura-blob aura-blob--${size} aura-blob--${mood}`}
      viewBox="0 0 180 160"
      role={size === "hero" ? "img" : undefined}
      aria-label={size === "hero" ? "Aura Blob mascot" : undefined}
      aria-hidden={size !== "hero"}
    >
      <path
        className="blob-body"
        d="M33 91C28 52 54 19 94 18c35-1 63 24 66 58 3 39-25 67-68 68-34 1-55-18-59-53Z"
      />
      <circle className="blob-eye" cx="75" cy="76" r="7" />
      <circle className="blob-eye" cx="113" cy="76" r="7" />
      <circle className="blob-cheek" cx="58" cy="93" r="8" />
      <circle className="blob-cheek" cx="130" cy="93" r="8" />
      <path className="blob-smile" d="M78 104c8 7 22 7 31 0" />
      <path className="blob-spark" d="M145 23l4 11 11 4-11 4-4 11-4-11-11-4 11-4 4-11Z" />
      <path className="blob-spark small" d="M32 31l3 7 7 3-7 3-3 7-3-7-7-3 7-3 3-7Z" />
    </svg>
  );
}
